import { detect } from 'detect-browser'
import ReactDOM from 'react-dom'
import { setupFullStory } from './common/integrations/fullstory'
import { setupIntercom } from './common/integrations/intercom'
import './common/style/fonts.css'
import { syncViewHeightCssVariable } from './common/style/view-height'
import './i18n/config'
import { CompatibilityPage } from './incompatibility/IncompatibilityPage'
import { Landing } from './landing'
import * as serviceWorker from './serviceWorker'

syncViewHeightCssVariable()
Math.random() < 0.01 && setupFullStory()
setupIntercom()

const browser = detect()

ReactDOM.render(
  browser && browser.name === 'ie' ? <CompatibilityPage /> : <Landing />,
  document.getElementById('root')
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
